module.exports = __webpack_public_path__ + "static/media/header_main_logo.589df4dd.svg";